import { useQuery } from '@tanstack/react-query';
import { apiClient } from '../../../services/apiClient';

type AttributeNode = {
  id: string;
  key: string;
  label: string;
  type: 'group' | 'option' | 'numeric';
  metadata?: Record<string, unknown> | null;
  sort_order?: number;
  prompt_text?: string | null;
  is_sensitive?: boolean;
  section?: string | null;
  section_order?: number | null;
  is_prompt_prefix?: boolean;
  children?: AttributeNode[];
};

type PromptSection = {
  key: string;
  label_ja: string;
  display_order: number;
  effective_order?: number;
};

type AttributeResponse = {
  items: AttributeNode[];
  sections?: PromptSection[];
};

/**
 * プロンプト属性ツリーを取得する。
 *
 * @param options.publicPartnerCode 指定すると認証不要の公開エンドポイント
 *   (/generation/attributes/public) からテンプレートセクションのみ取得する。
 *   公開ホーム (未ログイン閲覧) 用。queryKey を分離しているため、ログイン後の
 *   認証付きツリーとキャッシュが混ざることはない。
 */
export function usePromptAttributes(options?: { publicPartnerCode?: string }) {
  const publicPartnerCode = options?.publicPartnerCode;
  return useQuery({
    queryKey: publicPartnerCode
      ? ['prompt', 'attributes', 'public', publicPartnerCode]
      : ['prompt', 'attributes'],
    queryFn: async () => {
      const { data } = await apiClient.get<AttributeResponse>(
        publicPartnerCode
          ? `/generation/attributes/public?partner_code=${encodeURIComponent(publicPartnerCode)}`
          : '/generation/attributes',
      );
      return data;
    },
    staleTime: 60_000,
  });
}

